import { N as Notyf } from './notyf-DIw0RvBj.js';

class LocalizationForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.returnTo = this.form.querySelector('input[name="return_to"]');
    this.countrySelect = this.querySelector('select[name="country_code"]');
    this.languageSelect = this.querySelector('select[name="language_code"]');
    this.countryOptions = this.querySelectorAll('[data-country]');
    this.languageOptions = this.querySelectorAll('[data-value]:not([data-country])');
    this.contentSelectButton = this.querySelector(
      'content-select[id="localization-language"] [data-select-button]'
    );

    this.form.addEventListener('submit', this.handleSubmit.bind(this));
    this.initialLanguageSwitch();
    this.addCountryClickListeners();
  }

  handleSubmit(event) {
    event.preventDefault();

    if (this.countrySelect.value) {
      // Check if the 'country' parameter exists and if not add it to the URL
      if (this.returnTo.value.match(/(\?|&)country=[^&]*/)) {
        // Replace the existing country parameter
        this.returnTo.value = this.returnTo.value.replace(
          /(\?|&)country=[^&]*/,
          `$1country=${this.countrySelect.value}`
        );
      } else {
        // Add the country parameter
        if (this.returnTo.value.includes('?')) {
          this.returnTo.value += `&country=${this.countrySelect.value}`;
        } else {
          this.returnTo.value += `?country=${this.countrySelect.value}`;
        }
      }
      // Update the Orbe cookie for country code
      document.cookie = `mdApp_countryCodeDomain=${this.countrySelect.value}; path=/; max-age=${60 * 60 * 24 * 60};`;
    }

    if (this.languageSelect.value) {
      // Update the Orbe cookie for language code
      document.cookie = `mdApp_showRecommendationLang=${this.languageSelect.value}; path=/; max-age=${60 * 60 * 24 * 60};`;
    }

    this.form.submit();
  }

  /**
   * Add click listeners to country options
   */
  addCountryClickListeners() {
    this.countryOptions.forEach((option) => {
      option.addEventListener('click', () => {
        this.languageSwitch(option.dataset.availableLanguages);
      });
    });
  }

  /**
   * Initial language switch
   */
  initialLanguageSwitch() {
    const currentCode = this.countrySelect.value;
    const countryOption = [...this.countryOptions].find((opt) => opt.dataset.value === currentCode);
    const availableLanguages = countryOption?.dataset.availableLanguages;

    if (availableLanguages) {
      this.languageSwitch(availableLanguages);
    } else {
      console.error("No available languages for the selected country");
      Notyf.error(window.toast_translations.localization.error);
    }
  }

  /**
   * Language switch
   * @param {string} availableLanguages - Comma-separated list of available language ISO codes
   */
  languageSwitch(availableLanguages) {
    const languages = availableLanguages.split(',');
    const currentLang = this.languageSelect.value;
    const languageToSelect = this.getAvailableLanguageToSelect(languages, currentLang);

    this.toggleLanguageOptions(languages);

    if (languageToSelect !== currentLang) {
      this.languageSelect.value = languageToSelect;
      this.languageSelect.dispatchEvent(new Event('change', { bubbles: true }));
      this.updateLanguageUI(languageToSelect);
    }
  }

  /**
   * Get available language to select
   * @param {string[]} list - List of available language ISO codes
   * @param {string} current - Current language ISO code
   * @return {string} - Available language ISO code
   */
  getAvailableLanguageToSelect(list, current) {
    return list.includes(current) ? current : list[0];
  }

  /**
   * Toggle language options
   * @param {string[]} available - List of available language ISO codes
   */
  toggleLanguageOptions(available) {
    this.languageOptions.forEach((option) => {
      const code = option.dataset.value;
      const visible = available.includes(code);
      this.toggleOption(option, visible);
    });
  }

  /**
   * Toggle option
   * @param {HTMLElement} option - Option to toggle
   * @param {boolean} visible - Whether the option is visible
   */
  toggleOption(option, visible) {
    option.classList.toggle('hidden', !visible);
    if (!visible && option.hasAttribute('data-selected')) option.removeAttribute('data-selected');
  }

  updateLanguageUI(languageCode) {
    const selectedOption = [...this.languageOptions].find(
      (opt) => opt.dataset.value === languageCode
    );

    if (!selectedOption) return console.error(`Language option for ${languageCode} not found`);

    this.languageOptions.forEach((opt) => opt.removeAttribute('data-selected'));
    selectedOption.setAttribute('data-selected', '');

    if (this.contentSelectButton) this.contentSelectButton.textContent = selectedOption.textContent;
  }
}

customElements.define('localization-form', LocalizationForm);
